import React, { useEffect, useState } from 'react';
import { saleAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { fmtDate } from '../utils/date';
import BackButton from '../components/BackButton';

const STATUS_COLOR = { paid: '#22c55e', partial: '#f59e0b', debt: '#ef4444' };

export default function RevenueDetail() {
  const { business } = useAuth();
  const [sales, setSales]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    saleAPI.list().then(r => setSales(r.data.sales || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fmt = (n) => new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

  const total = sales.reduce((s, t) => s + Number(t.total_amount), 0);

  if (loading) return <div className="page"><p className="text-muted">Loading…</p></div>;

  return (
    <div className="page">
      <BackButton />
      <h1 className="page-title">Revenue</h1>
      <p className="text-muted" style={{ marginBottom: '0.25rem' }}>All sales transactions</p>
      <p style={{ fontWeight: 700, fontSize: '1.3rem', marginBottom: '1.25rem' }}>
        {business?.currency} {fmt(total)}
      </p>

      {sales.length === 0 && <p className="text-muted">No sales recorded yet.</p>}

      {sales.map(s => (
        <div key={s.id} className="card" style={{ marginBottom: '0.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>{s.product_name}</div>
              <div className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.15rem' }}>
                {s.buyer_name || 'Walk-in'} · Qty {s.qty} · {fmtDate(s.sold_at)}
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: '0.75rem' }}>
              <div style={{ fontWeight: 700 }}>{business?.currency} {fmt(s.total_amount)}</div>
              <div style={{ fontSize: '0.75rem', fontWeight: 600, color: STATUS_COLOR[s.payment_status] || '#94a3b8', marginTop: '0.15rem', textTransform: 'capitalize' }}>
                {s.payment_status}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
